const BaseUrl = process.env.REACT_APP_BASE_URL;  
// const BaseUrl = 'http://127.0.0.1:8000/api/';
// const BaseUrl = 'https://dev-backend.linyay.com/api/';

export default BaseUrl;